import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  CardReconciliationDto,
  CardReconciliationListDto,
  CardReconciliationFilterDto,
  CreateCardReconciliationRequest,
  AutoMatchRequest,
  AutoMatchResult,
  ManualMatchRequest,
} from '@/types/cardReconciliation.types';

export const cardReconciliationApi = {
  /** GET /api/v1/card-reconciliations */
  getList: (filter?: CardReconciliationFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<CardReconciliationListDto>>>('/card-reconciliations', { params: filter }),

  /** GET /api/v1/card-reconciliations/{id} */
  getById: (id: string) =>
    apiClient.get<ApiResponse<CardReconciliationDto>>(`/card-reconciliations/${id}`),

  /** POST /api/v1/card-reconciliations */
  create: (data: CreateCardReconciliationRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/card-reconciliations', data),

  // ── Matching ──────────────────────────────────────────────────────────────

  /** POST /api/v1/card-reconciliations/{id}/auto-match */
  autoMatch: (id: string, req: AutoMatchRequest) =>
    apiClient.post<ApiResponse<AutoMatchResult>>(`/card-reconciliations/${id}/auto-match`, req),

  /** POST /api/v1/card-reconciliations/{id}/manual-match */
  manualMatch: (id: string, req: ManualMatchRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>(`/card-reconciliations/${id}/manual-match`, req),

  /** DELETE /api/v1/card-reconciliations/{id}/lines/{lineId}/match */
  clearMatch: (id: string, lineId: string) =>
    apiClient.delete<ApiResponse<object>>(`/card-reconciliations/${id}/lines/${lineId}/match`),

  // ── Workflow ──────────────────────────────────────────────────────────────

  /** POST /api/v1/card-reconciliations/{id}/submit */
  submit: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/card-reconciliations/${id}/submit`),

  /** POST /api/v1/card-reconciliations/{id}/approve */
  approve: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/card-reconciliations/${id}/approve`),

  /** POST /api/v1/card-reconciliations/{id}/reject */
  reject: (id: string, reason: string) =>
    apiClient.post<ApiResponse<object>>(`/card-reconciliations/${id}/reject`, { reason }),

  /** POST /api/v1/card-reconciliations/{id}/post */
  post: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/card-reconciliations/${id}/post`),

  /** POST /api/v1/card-reconciliations/{id}/reverse */
  reverse: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/card-reconciliations/${id}/reverse`),
};
